module.exports = __webpack_public_path__ + "img/1970East-028_WEB-min.7261469f.jpg";